import React from 'react'
import { Column, Header, Row, View, Intro, LinksList } from 'components/Layout'

import { AppListContainer } from '../../containers'
// import Helmet from '../../assets/intros/helmet.svg'

import Media from 'react-media'

const Dashboard = () => {
	const sideLinks = [
		{
			title: 'See the docs',
			desc: 'Check out the documentation on chat.io APIs.',
			link: process.env.REACT_APP_DEV_DOCS_URL
		},
		{
			title: 'Explore',
			desc: 'Take a peek at developers resources from chat.io',
			path: '/explore'
		}
	]

	return (
		<View>
			<Media query={{ minWidth: 480 }}>
				<Header>
					<Row center>
						<Column width={3}>
							<Intro
								header={'Your Apps'}
								body={
									'Create, develop and distribute chat.io apps and extensions.'
								}
							/>
						</Column>
					</Row>
				</Header>
			</Media>
			<Row topMargin>
				<Column width={9}>
					<AppListContainer />
				</Column>
				<Column width={3}>
					<LinksList
						header={'Got stuck somewhere?'}
						links={sideLinks}
					/>
				</Column>
			</Row>
		</View>
	)
}
export default Dashboard



// WEBPACK FOOTER //
// ./src/views/Apps/Dashboard.js